import SharedHelperText from '@shared/components/helper-text';

const HelperText = (props) => (
  <SharedHelperText { ...props } />
);

export default HelperText;
